import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginBenefits = () => {
  const benefits = [
    {
      icon: 'TrendingUp',
      title: 'Track Your Finances',
      description: 'Monitor income, expenses, and net worth in real-time with comprehensive dashboards'
    },
    {
      icon: 'PieChart',
      title: 'Smart Categorization',
      description: 'Automatic transaction categorization with customizable rules and insights'
    },
    {
      icon: 'Target',
      title: 'Achieve Your Goals',
      description: 'Set financial milestones and track progress with achievement system'
    },
    {
      icon: 'FileSpreadsheet',
      title: 'Easy CSV Import',
      description: 'Import bank statements seamlessly with automatic processing and categorization'
    }
  ];

  return (
    <div className="mt-48 md:mt-56 lg:mt-64">
      <div className="text-center mb-32 md:mb-40">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground mb-12">
          Why Choose Rovyn Budget?
        </h2>
        <p className="text-sm md:text-base text-muted-foreground font-caption max-w-2xl mx-auto">
          Join thousands of users who have taken control of their financial future with our premium budgeting platform
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-20 md:gap-24 lg:gap-32">
        {benefits?.map((benefit, index) => (
          <div
            key={index}
            className="bg-card rounded-xl p-20 md:p-24 lg:p-28 shadow-elevation-2 hover:shadow-elevation-3 transition-smooth"
          >
            <div className="flex items-start gap-16">
              <div className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-lg flex-shrink-0">
                <Icon name={benefit?.icon} size={24} color="var(--color-primary)" strokeWidth={2} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-8">
                  {benefit?.title}
                </h3>
                <p className="text-sm md:text-base text-muted-foreground font-caption">
                  {benefit?.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoginBenefits;